import React from 'react';
import * as TsLib from 'tslib';
import JsxRuntime from 'react/jsx-runtime';
import * as ComponentMatrix from '@powerednow/components/layout/ComponentMatrix';
import * as NumberField from '@powerednow/components/fields/NumberField';
import * as CurrencyField from '@powerednow/components/fields/CurrencyField';
import * as TimePicker from '@powerednow/components/fields/TimePicker';
import * as Select from '@powerednow/components/fields/Select';
import * as useStateControl from '@powerednow/components/hooks/useStateControl';
import * as Fieldset from '@powerednow/components/fields/Fieldset';
import * as Constants from '@powerednow/shared/constants';
import * as Box from '@powerednow/components/Box/Box';

export default class BundleRunnerEnvironment {
    module = null;

    requiredModules = {
        react: React,
        tslib: TsLib,
        'react/jsx-runtime': JsxRuntime,
        '@powerednow/shared/constants': Constants,
        '@powerednow/components/fields/NumberField': NumberField,
        '@powerednow/components/fields/CurrencyField': CurrencyField,
        '@powerednow/components/fields/TimePicker': TimePicker,
        '@powerednow/components/layout/ComponentMatrix': ComponentMatrix,
        '@powerednow/components/fields/Select': Select,
        '@powerednow/components/fields/Fieldset': Fieldset,
        '@powerednow/components/hooks/useStateControl': useStateControl,
        '@powerednow/components/Box/Box': Box,
    };

    constructor(string) {
        this.assignRuntimeEnvironment();
        // eslint-disable-next-line no-new-func
        const fn = new Function('self', `return ${string}`);
        this.module = fn.call(this, this);
    }

    dynamicBundleLoader(module) {
        return module;
    }

    assignRuntimeEnvironment() {
        Object.keys(this.requiredModules).forEach(key => {
            this[key] = this.requiredModules[key];
        });
    }
}
